import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Box} from '@spothero/ui';
import {Button} from '@spothero/ui-backlog';
import AmenityUtils from '@spothero/utils/amenity';
import {updateFilters} from 'store/filters/filters-actions';
import {isMoreThan24Hours} from 'utils/time';

const SearchTransientInOutFilter = () => {
    const IconAmenity = AmenityUtils.getIcon('in-out');
    const dispatch = useDispatch();
    const {
        city: {
            data: {display_name: cityName},
        },
        filters: {activeAmenities},
        searchRequest: {starts, ends},
    } = useSelector(state => state);

    const isInOutAmenityFilterApplied = activeAmenities.includes('in-out');
    // Search uses 30 minute increments, so we need to round up to the nearest hour
    const isSearchDurationMoreThan24Hours = isMoreThan24Hours({
        starts,
        ends,
    });
    const isSearchCityNYC = cityName === 'NYC';
    const isVisible = isSearchDurationMoreThan24Hours && !isSearchCityNYC;

    const toggleInOutOnClick = () => {
        const newActiveAmenities = isInOutAmenityFilterApplied
            ? activeAmenities.filter(amenity => amenity !== 'in-out')
            : [...activeAmenities, 'in-out'];

        dispatch(
            updateFilters({
                activeAmenities: newActiveAmenities,
            })
        );
    };

    const stylingProps = {
        '.QuickFilters-filter': {
            marginLeft: '0px',
            ...(isInOutAmenityFilterApplied
                ? {
                      backgroundColor: 'consumer.shiftLight',
                      color: 'brandBlue',
                      borderColor: 'brandBlue',
                  }
                : {}),
        },
        '.QuickFilters-filter:hover': {
            backgroundColor: isInOutAmenityFilterApplied
                ? 'consumer.shiftLight'
                : 'consumer.blackLight',
        },
    };

    return isVisible ? (
        <Box sx={stylingProps}>
            <Button
                className="QuickFilters-filter"
                data-testid="QuickFilters-in-out"
                onClick={toggleInOutOnClick}
            >
                <IconAmenity /> In &amp; Out
            </Button>
        </Box>
    ) : null;
};

export default SearchTransientInOutFilter;
